/*
   Bold Grip Socks — "discount applied" confirmation toast.

   A promo CTA points at:
     /discount/BOLDME20?redirect=%2Fproducts%2Fbold-6pack%3Fpromo%3DBOLDME20
   Shopify applies the code, then lands on /products/bold-6pack?promo=BOLDME20.
   This reads ?promo=, confirms with a toast, and strips the param so a
   refresh or a shared link does not re-trigger it.

   Inert with no ?promo= in the URL. Remove the two tags in theme.liquid to disable.
*/
(function () {
  var FADE_MS = 4500;

  function getParam(name) {
    try { return new URL(window.location.href).searchParams.get(name); }
    catch (e) { return null; }
  }

  var raw = getParam('promo');
  if (!raw) return;

  // URL-supplied, so constrain it before it ever reaches the DOM.
  var code = String(raw).trim().toUpperCase();
  if (!/^[A-Z0-9_-]{1,32}$/.test(code)) return;

  try {
    var u = new URL(window.location.href);
    u.searchParams.delete('promo');
    history.replaceState({}, document.title, u.pathname + u.search + u.hash);
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { toast(code); });
  } else {
    toast(code);
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function toast(code) {
    if (document.querySelector('[data-bm-promo-toast]')) return;
    var el = document.createElement('div');
    el.className = 'bm-promo-toast';
    el.setAttribute('data-bm-promo-toast', '');
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="bm-promo-toast__tick" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
      '</span>' +
      '<div class="bm-promo-toast__text">' +
        '<p class="bm-promo-toast__title">' + escapeHtml(code) + ' discount applied</p>' +
        '<p class="bm-promo-toast__sub">You will see it at checkout</p>' +
      '</div>' +
      '<button type="button" class="bm-promo-toast__x" aria-label="Dismiss">&times;</button>';

    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });

    var timer = setTimeout(dismiss, FADE_MS);
    function dismiss() {
      clearTimeout(timer);
      el.classList.remove('is-in');
      el.classList.add('is-out');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 500);
    }
    el.querySelector('.bm-promo-toast__x').addEventListener('click', dismiss);
  }
})();
